import PropTypes from 'prop-types';

const spacing = { xs: 8, sm: 12, md: 16, lg: 24, xl: 32 };
const withSpacing = (value) => typeof value === 'string' ? `${spacing[value] ?? value}px` : typeof value === 'number' ? `${value}px` : value;

const FormField = ({ label, required, withAsterisk, hint, description, error, children, className = '', style, mt, mb, flex, w }) => (
	<div className={`q-form-field${className ? ` ${className}` : ''}`} style={{ marginTop: withSpacing(mt), marginBottom: withSpacing(mb), flex, width: withSpacing(w), ...style }}>
		{label && (
			<label className="q-form-label">
				{label}
				{(required || withAsterisk) && <span className="q-form-required"> *</span>}
			</label>
		)}
		{children}
		{error && <div className="q-form-error">{error}</div>}
		{!error && (hint || description) && <div className="q-form-hint">{hint ?? description}</div>}
	</div>
);

FormField.propTypes = {
	label: PropTypes.node,
	required: PropTypes.bool,
	withAsterisk: PropTypes.bool,
	hint: PropTypes.node,
	description: PropTypes.node,
	error: PropTypes.node,
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	style: PropTypes.object,
	mt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	mb: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	flex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	w: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default FormField;
